import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: [],
    links: {},
    meta: {}
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    SET_TIPO_USUARIO_LOADING: (state, loading) => {
      state.tipo_usuario.loading = loading;
    },

    SET_TIPO_USUARIO: (state, { data }) => {
      state.tipo_usuario.data = data;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    isTipoUsuarioLoading: state => () => {
      return state.tipo_usuario.loading;
    },

    getTiposUsuario: state => id => {
      if (id) {
        let tipo_usuario = state.tipo_usuario.data.filter(
          tipo_usuario => tipo_usuario.id == id
        );

        return tipo_usuario.length > 0 ? tipo_usuario[0] : null;
      }

      return state.tipo_usuario.data;
    },

    getTiposUsuarioMeta: state => () => {
      return state.tipo_usuario.meta;
    },

    getTiposUsuarioLinks: state => () => {
      return state.tipo_usuario.links;
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_TIPO_USUARIO({ commit, state }) {
      // Se ja esta buscando

      commit("SET_TIPO_USUARIO_LOADING", true);
      api()
        .get(`tipos-usuario`)
        // .get(`tipo_usuario`)
        .then(response => {
          if (response.data.status) {
            commit("SET_TIPO_USUARIO", response.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_TIPO_USUARIO_LOADING", false));
    },

    RESET_TIPO_USUARIO({ commit }) {
      commit("RESET_TIPO_USUARIO");
    }
  }
};

export default store;
